import { tooltipDriverFactory as coreTooltipDriverFactory } from '../internal/WixUiCoreComponents/components/CoreTooltip/CoreTooltip.driver';

export const tooltipDriverFactory = (component) => {
  const tooltipDriver = coreTooltipDriverFactory(component);

  return {
    ...tooltipDriver,
  };
};
